<template>
  <div class="container d-flex flex-column gap-4 align-items-start w-100 p-3 p-lg-5">
    <!-- Fila 1 -->
    <div class="d-flex flex-column flex-lg-row gap-4 align-items-center w-100">
      <div style="height: 400px; max-height: 400px;" class="d-flex flex-column w-100 position-relative gap-3">
        <div class="d-flex flex-column fondo-terciario rounded-5 sombra-sm p-2 px-3 w-100 position-relative overflow-hidden" style="height: 100%;">
          <div class="d-flex flex-row justify-content-between align-items-center">
            <p class="m-0 fs-4 p-2">{{ $t('usuariosConectados') }}:</p>
            <svg width="25" height="25" viewBox="0 1 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{ 'spinning': isSpinning }" @click="handleClick()" style="cursor: pointer;">
              <path class="fill-principal" fill-rule="evenodd" clip-rule="evenodd" d="M13.7071 1.29289C14.0976 1.68342 14.0976 2.31658 13.7071 2.70711L12.4053 4.00896C17.1877 4.22089 21 8.16524 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 12.4477 3.44772 12 4 12C4.55228 12 5 12.4477 5 13C5 16.866 8.13401 20 12 20C15.866 20 19 16.866 19 13C19 9.2774 16.0942 6.23349 12.427 6.01281L13.7071 7.29289C14.0976 7.68342 14.0976 8.31658 13.7071 8.70711C13.3166 9.09763 12.6834 9.09763 12.2929 8.70711L9.29289 5.70711C9.10536 5.51957 9 5.26522 9 5C9 4.73478 9.10536 4.48043 9.29289 4.29289L12.2929 1.29289C12.6834 0.902369 13.3166 0.902369 13.7071 1.29289Z"/>
            </svg>
          </div>
          <div v-if="loadingUsers" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
            <img src="../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
          </div>
          <div v-if="usersConectados != null && usersConectados.length > 0" style="height: 85%; overflow-y: auto; scrollbar-width: none;" class="mb-2 d-flex flex-column gap-2 justify-content-start p-2">
            <router-link v-for="(user) in usersConectados" :key="user.UserId" class="d-flex flex-column gap-2 w-100 border-0 sombra-sm fondo-secundario rounded-3 text-decoration-none texto-principal" :to="'/personas/verDatosPersona?id='+user.UserId">
              <div class="d-flex flex-row w-100 p-2 px-3 border border-0 fondo-terciario gap-2 sombra-sm rounded-3 align-items-center">
                <div class="d-flex align-items-center justify-content-center p-0">
                  <img v-if="user?.UserPhotoUrl" :src="user?.UserPhotoUrl" alt="Profile Picture" class="img-responsive" style="width: 45px; height: 45px; border-radius: 50%; object-fit: cover; padding: 2px;" />
                  <div v-if="!user?.UserPhotoUrl" alt="Profile Picture" class="d-flex align-items-center justify-content-center img-responsive pb-1" style="width: 45px; height: 45px; border-radius: 50%; background-color: #bbbbbb; object-fit: cover; padding: 2px;" >
                    <svg width="20" height="20" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Dribbble-Light-Preview" transform="translate(-140.000000, -2159.000000)" fill="#ffffff"><g id="icons" transform="translate(56.000000, 160.000000)"><path d="M100.562548,2016.99998 L87.4381713,2016.99998 C86.7317804,2016.99998 86.2101535,2016.30298 86.4765813,2015.66198 C87.7127655,2012.69798 90.6169306,2010.99998 93.9998492,2010.99998 C97.3837885,2010.99998 100.287954,2012.69798 101.524138,2015.66198 C101.790566,2016.30298 101.268939,2016.99998 100.562548,2016.99998 M89.9166645,2004.99998 C89.9166645,2002.79398 91.7489936,2000.99998 93.9998492,2000.99998 C96.2517256,2000.99998 98.0830339,2002.79398 98.0830339,2004.99998 C98.0830339,2007.20598 96.2517256,2008.99998 93.9998492,2008.99998 C91.7489936,2008.99998 89.9166645,2007.20598 89.9166645,2004.99998 M103.955674,2016.63598 C103.213556,2013.27698 100.892265,2010.79798 97.837022,2009.67298 C99.4560048,2008.39598 100.400241,2006.33098 100.053171,2004.06998 C99.6509769,2001.44698 97.4235996,1999.34798 94.7348224,1999.04198 C91.0232075,1998.61898 87.8750721,2001.44898 87.8750721,2004.99998 C87.8750721,2006.88998 88.7692896,2008.57398 90.1636971,2009.67298 C87.1074334,2010.79798 84.7871636,2013.27698 84.044024,2016.63598 C83.7745338,2017.85698 84.7789973,2018.99998 86.0539717,2018.99998 L101.945727,2018.99998 C103.221722,2018.99998 104.226185,2017.85698 103.955674,2016.63598" id="profile_round-[#1342]"></path></g></g></svg>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <p class="fs-6 m-0 text-start">{{user.Username}}</p>
                  <p class="fs-7 m-0 text-start texto-secundario">{{user.NivelSector}}</p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="d-flex flex-column flex-md-row gap-3 w-100">
          
          <a :href="linkLogs" class="d-flex flex-row gap-2 align-items-center fondo-terciario rounded-5 sombra-sm p-3 px-4 w-100 position-relative overflow-hidden text-decoration-none texto-principal" target="_blank">
            <svg class="fill-principal" width="28" height="28" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 24q0 0.832 0.576 1.44t1.44 0.576h1.984q0 2.496 1.76 4.224t4.256 1.76h6.688q-2.144-1.504-3.456-4h-3.232q-0.832 0-1.44-0.576t-0.576-1.408v-20q0-0.832 0.576-1.408t1.44-0.608h16q0.8 0 1.408 0.608t0.576 1.408v7.232q2.496 1.312 4 3.456v-10.688q0-2.496-1.76-4.256t-4.224-1.76h-16q-2.496 0-4.256 1.76t-1.76 4.256h-1.984q-0.832 0-1.44 0.576t-0.576 1.408 0.576 1.44 1.44 0.576h1.984v4h-1.984q-0.832 0-1.44 0.576t-0.576 1.408 0.576 1.44 1.44 0.576h1.984v4h-1.984q-0.832 0-1.44 0.576t-0.576 1.408zM10.016 24h2.080q0-0.064-0.032-0.416t-0.064-0.576 0.064-0.544 0.032-0.448h-2.080v1.984zM10.016 20h2.464q0.288-1.088 0.768-1.984h-3.232v1.984zM10.016 16h4.576q0.992-1.216 2.112-1.984h-6.688v1.984zM10.016 12h16v-1.984h-16v1.984zM10.016 8h16v-1.984h-16v1.984zM14.016 23.008q0 1.824 0.704 3.488t1.92 2.88 2.88 1.92 3.488 0.704 3.488-0.704 2.88-1.92 1.92-2.88 0.704-3.488-0.704-3.488-1.92-2.88-2.88-1.92-3.488-0.704-3.488 0.704-2.88 1.92-1.92 2.88-0.704 3.488zM18.016 23.008q0-2.080 1.44-3.52t3.552-1.472 3.52 1.472 1.472 3.52q0 2.080-1.472 3.52t-3.52 1.472-3.552-1.472-1.44-3.52zM22.016 23.008q0 0.416 0.288 0.704t0.704 0.288h1.984q0.416 0 0.704-0.288t0.32-0.704-0.32-0.704-0.704-0.288h-0.992v-0.992q0-0.416-0.288-0.704t-0.704-0.32-0.704 0.32-0.288 0.704v1.984z"></path>
            </svg>
            <p class="m-0 fs-4 flex-grow-1">{{$t('verLogs')}}</p>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="stroke-principal" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>

          <div class="d-flex flex-row align-items-center gap-3 fondo-terciario rounded-5 sombra-sm p-3 px-4 w-100 position-relative">
            <svg width="32" height="32" viewBox="0 0 800 742" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="a" width="168" height="154" x="12" y="18" maskUnits="userSpaceOnUse">
                <path fill="#fff" d="M63.09 37c14.626-25.333 51.193-25.334 65.819 0l45.033 78c14.626 25.334-3.657 57.001-32.91 57.001H50.967c-29.253 0-47.536-31.667-32.91-57.001Z"/>
              </mask>
              <g mask="url(#a)" transform="matrix(4.8140532,0,0,4.8140532,-62.146701,-86.652356)">
                <path fill="url(#b)" d="M206.905 172.02h-91.888l-19.015-32.934 45.944-79.578Z"/>
                <path fill="url(#c)" d="M-14.919 172.006 50.04 59.494v.002L31.032 92.422h38.02L115 172.004l-129.918.001Z"/>
                <path fill="url(#d)" d="M96.007-20.085 141.954 59.5l-19.011 32.928H31.048Z"/>
              </g>
              <defs>
                <linearGradient id="b" x1="193.6" x2="103.09" y1="165.6" y2="111.21" gradientUnits="userSpaceOnUse">
                  <stop offset=".09" stop-color="#ffe921"/>
                  <stop offset="1" stop-color="#fec700"/>
                </linearGradient>
                <linearGradient id="c" x1="114.4" x2="15.53" y1="181.61" y2="121.8" gradientUnits="userSpaceOnUse">
                  <stop offset=".15" stop-color="#a9a8ff"/>
                  <stop offset=".33" stop-color="#6d97ff"/>
                  <stop offset=".48" stop-color="#3186ff"/>
                </linearGradient>
                <linearGradient id="d" x1="128.88" x2="28.7" y1="37.88" y2="84.64" gradientUnits="userSpaceOnUse">
                  <stop offset=".55" stop-color="#0ebc5f"/>
                  <stop offset=".85" stop-color="#78c9ff"/>
                </linearGradient>
              </defs>
            </svg>
            
            <div class="d-flex flex-column justify-content-center flex-grow-1">
              <p class="m-0 fs-5 lh-1 texto-principal">{{$t('almacenamientoTreffpunkt')}}</p>
              <p v-if="loadingDrive" class="m-0 fs-7 texto-secundario mt-1">{{ $t('cargando') }}...</p>
              <p v-else-if="driveStorage" class="m-0 fs-7 texto-secundario mt-1">
                {{ driveStorage.ocupadoGB }} GB / {{ driveStorage.limiteGB > 0 ? driveStorage.limiteGB + ' GB' : 'Ilimitado' }}
              </p>
            </div>

            <div class="dropdown">
              <button class="bg-transparent border-0 d-flex align-items-center justify-content-center" type="button" id="driveMenu" data-bs-toggle="dropdown" aria-expanded="false" style="cursor: pointer;">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="fill-principal" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="5" r="2"/>
                  <circle cx="12" cy="12" r="2"/>
                  <circle cx="12" cy="19" r="2"/>
                </svg>
              </button>
              <ul class="dropdown-menu dropdown-menu-end sombra-sm border-0 mt-2 p-2 rounded-3 fondo-secundario" aria-labelledby="driveMenu">
                <li>
                  <a class="dropdown-item rounded-2 texto-rojo d-flex align-items-center gap-2" href="#" data-bs-toggle="modal" data-bs-target="#modalLimpiezaDrive">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="3 6 5 6 21 6"></polyline>
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                    {{$t('eliminarArchivosViejos')}}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          
        </div>
        
      </div>

    </div>
    
    <div class="d-flex flex-column gap-3 fondo-terciario rounded-5 sombra-sm p-3 px-lg-4 w-100">
      <div class="d-flex flex-column justify-content-between align-items-center gap-2">
        <div class="d-flex flex-row flex-wrap justify-content-between align-items-center gap-2 w-100">
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-center gap-2">
            <p class="m-0 fs-4 text-nowrap ps-1">{{ $t('gestionTokens') }}</p>
            <!-- Controles de Paginación Tokens --> 
            <nav aria-label="Page navigation" class="d-flex flex-row w-auto">
              <ul class="pagination m-0">
                <li :class="{ disabled: paginationTokens.pageNumber === 1 }">
                  <a class="text-dark text-decoration-none" href="#" @click.prevent="fetchRefreshTokens(paginationTokens.pageNumber - 10)">
                    <svg width="20" height="20" viewBox="3 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)">
                      <path d="m13 16 4-4-4-4M7 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </li>
                <li :class="{ disabled: paginationTokens.pageNumber === 1 }">
                  <a class=" text-dark text-decoration-none" href="#" @click.prevent="fetchRefreshTokens(paginationTokens.pageNumber - 1)">
                    <svg width="20" height="20" viewBox="3 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)">
                      <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </li>
                <li>
                  <a class="p-1 texto-principal text-decoration-none text-nowrap m-0" href="#" @click.prevent="">{{ paginationTokens.pageNumber }} {{$t('de')}} {{ paginationTokens.totalPages }}</a>
                </li>
                <li :class="{ disabled: paginationTokens.pageNumber === paginationTokens.totalPages }">
                  <a class="p-1 text-dark text-decoration-none" href="#" @click.prevent="fetchRefreshTokens(paginationTokens.pageNumber + 1)">
                    <svg width="20" height="20" viewBox="3 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </li>
                <li :class="{ disabled: paginationTokens.pageNumber === paginationTokens.totalPages }">
                  <a class="text-dark text-decoration-none" href="#" @click.prevent="fetchRefreshTokens(paginationTokens.pageNumber + 10)">
                    <svg width="20" height="20" viewBox="3 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="m13 16 4-4-4-4M7 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <svg width="25" height="25" viewBox="0 1 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{ 'spinning': isSpinningToken }" @click="handleClickToken(paginationTokens.pageNumber)" style="cursor: pointer;">
            <path class="fill-principal" fill-rule="evenodd" clip-rule="evenodd" d="M13.7071 1.29289C14.0976 1.68342 14.0976 2.31658 13.7071 2.70711L12.4053 4.00896C17.1877 4.22089 21 8.16524 21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 12.4477 3.44772 12 4 12C4.55228 12 5 12.4477 5 13C5 16.866 8.13401 20 12 20C15.866 20 19 16.866 19 13C19 9.2774 16.0942 6.23349 12.427 6.01281L13.7071 7.29289C14.0976 7.68342 14.0976 8.31658 13.7071 8.70711C13.3166 9.09763 12.6834 9.09763 12.2929 8.70711L9.29289 5.70711C9.10536 5.51957 9 5.26522 9 5C9 4.73478 9.10536 4.48043 9.29289 4.29289L12.2929 1.29289C12.6834 0.902369 13.3166 0.902369 13.7071 1.29289Z"/>
          </svg>
        </div>
        <div class="d-flex flex-row gap-3 w-100 w-md-auto">
          <div class="d-flex align-items-center position-relative w-100 gap-2">
            <!-- Ícono SVG de lupa -->
            <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" class="position-absolute top-50 start-0 translate-middle-y ms-2 text-secondary" style="pointer-events: none">
              <path d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z" stroke="currentColor"  fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <input type="text" class="form-control m-0 rounded-3 borde-secundario fondo-secundario sombra" :placeholder="$t('buscarPorNombre') + '...'" v-model="filtersTokens.searchTerm"
              style="padding-left: 35px;"/>
            <button v-if="filtersTokens.searchTerm" type="button" class="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent" @click="filtersTokens.searchTerm = ''">
              <i class="bi bi-x text-secondary" style="font-size: 30px;"></i> <!-- Icono de "x" -->
            </button>
          </div>
          
          <a href="https://www.canva.com/design/DAGzKnFC8A4/8bM5dFhnsnCQFNNn07G7XQ/edit?utm_content=DAGzKnFC8A4&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton"
            class="d-flex flex-row text-decoration-none align-items-center justify-content-start gap-1" target="_blank">
            <p class="m-0 fs-6 texto-secundario">{{ $t('instructivo') }}</p>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="stroke-secundario" xmlns="http://www.w3.org/2000/svg">
              <path id="Vector" d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      </div>

      <div class="d-flex flex-wrap gap-2">
        <div 
          class="form-check-pill"
          :class="{ 'checked': filtersTokens.status === 'activo' }"
          @click="setTokenStatusFilter('activo')">
          <span>{{ $t('activo') }}</span>
        </div>
        <div 
          class="form-check-pill"
          :class="{ 'checked': filtersTokens.status === 'revocado' }"
          @click="setTokenStatusFilter('revocado')">
          <span>{{ $t('revocado') }}</span>
        </div>
        <div 
          class="form-check-pill"
          :class="{ 'checked': filtersTokens.status === 'antiguo' }"
          @click="setTokenStatusFilter('antiguo')">
          <span>{{ $t('antiguo') }}</span>
        </div>
        <div 
          class="form-check-pill"
          :class="{ 'checked': filtersTokens.status === 'expirado' }"
          @click="setTokenStatusFilter('expirado')">
          <span>{{ $t('expirado') }}</span>
        </div>
      </div>

      <div v-if="loadingTokens" class="d-flex justify-content-center align-items-center p-5">
        <img src="../assets/LOADING.gif" style="width: 50px;" alt="Cargando..." />
      </div>

      <div v-if="!loadingTokens && refreshTokens.length > 0" class="d-flex flex-column gap-2">
        <div v-for="token in refreshTokens" :key="token.id" class="d-flex flex-row flex-xs-row align-items-center gap-3 p-2 fondo-terciario rounded-3 sombra">
          <div class="d-flex align-items-center gap-3 ps-2 text-decoration-none texto-principal" style="flex: 4;">
            <router-link class="d-flex text-decoration-none texto-principal" :to="'/personas/verDatosPersona?id='+token.persona.idPersona">
              <img v-if="token.persona.fotoUrl" :src="token.persona.fotoUrl" class="rounded-circle" style="width: 40px; height: 40px; object-fit: cover;"/>
              <div v-else class="rounded-circle bg-secondary d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
              </div>
            </router-link>
            <div class="text-start">
              <router-link class="d-flex text-decoration-none texto-principal" :to="'/personas/verDatosPersona?id='+token.persona.idPersona">
                <p class="m-0 fw-bold">{{ token.persona.apellido + ' ' + token.persona.nombre }}</p>
              </router-link>
              <p class="m-0 d-block d-md-none texto-secundario">{{ 'Token' + ': ' + token.token.substring(0, 10) }}...</p>
              <p class="m-0 d-none d-md-block d-xl-none texto-secundario">{{ 'Token' + ': ' + token.token.substring(0, 20) }}...</p>
              <p class="m-0 d-none d-xl-block texto-secundario">{{ 'Token' + ': ' + token.token.substring(0, 30) }}...</p>
            </div>
          </div>
          <div class="text-start" style="flex: 3;">
            <p class="m-0 texto-secundario fs-7">
              <span class="fw-bold">{{ $t('creado') }}:</span> {{ formatDate(token.created) }}
            </p>
            <p class="m-0 texto-secundario fs-7">
              <span class="fw-bold">{{ $t('expira') }}:</span> {{ formatDate(token.expires) }}
            </p>
          </div>
          <div class="text-start text-md-end d-inline-flex flex-row gap-1" style="flex: 1;">
            <span class="rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-1 px-2 sombra-sm"
              :class="{ 'select-aprobado': getTokenStatus(token).text == 'activo',
                'select-desaprobado': getTokenStatus(token).text == 'revocado',
                'select-nada': getTokenStatus(token).text == 'expirado' || getTokenStatus(token).text == 'antiguo'}">
              {{ $t(getTokenStatus(token).text) }}
            </span>
            <div v-if="getTokenStatus(token).text === 'activo'" class="ps-2" style="flex: 0 0 auto; height: 32px">
              <button 
                @click="revokeToken(token)"
                class="btn btn-danger btn-sm border-0 select-desaprobado d-flex align-items-center justify-content-center"
                :disabled="revokingTokenId === token.id"
                style="--bs-btn-padding-y: .2rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem; height: 100%">
                
                <span v-if="revokingTokenId === token.id" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                
                <svg v-else width="16" height="16" viewBox="7 7 10 10" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 9L9 15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 9L15 15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="!loadingTokens && refreshTokens.length === 0" class="text-center texto-secundario p-5">
        <p>{{ $t('noSeEncontraronTokens') }}</p>
      </div>
    </div>
    <div class="modal fade" id="modalLimpiezaDrive" tabindex="-1" aria-labelledby="modalLimpiezaDriveLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 sombra rounded-4 p-2 w-100">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title texto-principal fw-bold d-flex align-items-center gap-2" id="modalLimpiezaDriveLabel">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#dc3545" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
              Advertencia
            </h5>
            <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btnCloseModalLimpieza"></button> -->
            <button type="button" class="btn p-0" data-bs-dismiss="modal" aria-label="Close" id="btnCloseModalLimpieza">
              <svg width="20" height="20" viewBox="5 5 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect id="Rectangle" fill-rule="nonzero" x="0" y="0" width="24" height="24"></rect>
                  <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
                  <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
                </g>
              </svg>
            </button>
          </div>
          <div class="modal-body texto-secundario fs-6"> 
            {{ $t('eliminarArchivosViejosConfirmacion') }}
            <br><br>
            <strong class="text-danger">{{ $t('noSePodraVolverAtras') }}</strong>
          </div>
          <div class="modal-footer border-0 pt-0">
            <button type="button" class="btn secondary-btn rounded-3 px-4 fw-bold sombra-sm" data-bs-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-danger rounded-3 px-4 d-flex align-items-center gap-2 fw-bold sombra-sm" @click="ejecutarLimpiezaDrive" :disabled="isCleaningDrive">
              <span v-if="isCleaningDrive" class="spinner-border spinner-border-sm" role="status"></span>
              <span>{{ isCleaningDrive ? 'Iniciando proceso...' : 'Sí, eliminar todo' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, onMounted, ref, onBeforeUnmount, watch} from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';
import { API_BASE_URL } from '@/config';


export default {
  name: "PanelAdmin",
  setup() {
    const { t } = useI18n();
    const message = ref('You are not logged in!');
    const imageUrl = ref(''); // For storing the image URL
    const store = useStore();
    const router = useRouter();
    const user = computed(() => store.state.user);

    let usersConectados = ref([])
    let loadingUsers = ref(false)
    let isSpinning = ref(false)
    let isSpinningToken = ref(false)
    const connectedUsers = computed(() => store.getters.getConnectedUsers);

    const driveStorage = ref(null);
    const loadingDrive = ref(false);
    const isCleaningDrive = ref(false);

    let interval;

    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        if(user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation.permiso === 'Formularios') || user.value.email.some(emails => emails.email.includes('@goethe.edu.ar'))){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
      }
    };
    
    const isTokenValid = () => {
      const token = localStorage.getItem('authToken')
      if (!token) return false;
      
      try {
        const [, payloadBase64] = token.split('.');
        const payload = JSON.parse(atob(payloadBase64));
        const currentTime = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
        return payload.exp > currentTime; // Comparar el tiempo de expiración
      } catch (error) {
        console.error('Error al decodificar el token:', error);
        return false;
      }
    };
    
    // === FUNCIONES DE GOOGLE DRIVE ===
    const fetchDriveStorage = async () => {
      loadingDrive.value = true;
      try {
        const response = await api.get('/api/Archivos/almacenamiento');
        driveStorage.value = response.data;
      } catch (error) {
        console.error('Error al obtener la cuota de Drive:', error);
      } finally {
        loadingDrive.value = false;
      }
    };

    const ejecutarLimpiezaDrive = async () => {
      isCleaningDrive.value = true;
      try {
        const response = await api.delete('/api/Archivos/eliminarViejos');
        
        // Cerramos el modal programáticamente simulando un click en la "X"
        const btnClose = document.getElementById('btnCloseModalLimpieza');
        if(btnClose) btnClose.click();

        // Mostramos el mensaje de éxito que manda el backend
        alert(response.data?.mensaje);
        
        // Opcional: Podés hacer un setTimeout para llamar a fetchDriveStorage() en un par 
        // de minutos si querés que la vista se actualice sola, ya que ahora corre de fondo.
      } catch (error) {
        console.error('Error al intentar iniciar la limpieza de Drive:', error);
        alert('Ocurrió un error al intentar iniciar el proceso.');
      } finally {
        isCleaningDrive.value = false;
      }
    };

    const fetchUsers = async () => {
      try {
        loadingUsers.value = true;
        const response = await api.get(`api/UsuariosConectados`);
        usersConectados.value = response.data
        
        console.log(usersConectados.value)
        
        usersConectados.value.sort((a, b) => {
          const dateA = new Date(a.ConnectedAt);
          const dateB = new Date(b.ConnectedAt);
          
          return dateB.getTime() - dateA.getTime();
        });
        loadingUsers.value = false;
      } catch (error) {
        console.error('Error al obtener los menus:', error);
        loadingUsers.value = false;
      }
    };
    
    const handleClick = async () => {
      // Evita que la animación se dispare varias veces si se hace clic muy rápido
      if (isSpinning.value) {
        return;
      }

      isSpinning.value = true; // Activa la animación
      
      // Una vez que la animación termina, ejecuta la función original
      fetchUsers(); 
      
      // Espera a que la animación termine (1 segundo en este caso)
      await new Promise(resolve => setTimeout(resolve, 200)); 
      
      isSpinning.value = false; // Desactiva la animación para permitirla de nuevo
    }


    const handleClickToken = async (currentPageToken) => {
      // Evita que la animación se dispare varias veces si se hace clic muy rápido
      if (isSpinningToken.value) {
        return;
      }

      isSpinningToken.value = true; // Activa la animación
      
      // Una vez que la animación termina, ejecuta la función original
      fetchRefreshTokens(currentPageToken); 
      
      // Espera a que la animación termine (1 segundo en este caso)
      await new Promise(resolve => setTimeout(resolve, 200)); 
      
      isSpinningToken.value = false; // Desactiva la animación para permitirla de nuevo
    }

    // **2. Observar los cambios en `connectedUsers` (la computada del store)**
    // Cada vez que el array `connectedUsers` en el store cambie (porque SignalR añadió/quitó un usuario),
    // este watcher se disparará y volverá a llamar a `fetchAndSetConnectedUsersFromApi()`.
    watch(connectedUsers => {
      console.log('Detectado cambio en connectedUsers en el store. Recargando desde API...', connectedUsers);
      fetchUsers();
    }, {
      deep: true
    });



    // Variables reactivas para los tokens
    const refreshTokens = ref([]);
    const loadingTokens = ref(false);
    const paginationTokens = ref({
        pageNumber: 1,
        totalPages: 1,
        totalCount: 0,
        pageSize: 10
    });

    // Variables reactivas para los filtros
    const filtersTokens = ref({
        status: 'activos', // Valor inicial del filtro
        searchTerm: '',
    });
    let searchTimeout = null; // Para el debouncing de la búsqueda

    // Función para llamar al endpoint de la API
    const fetchRefreshTokens = async (page = 1) => {
      if(page<=0){
        page = 1
      }
      if(page >= paginationTokens.value.totalPages && paginationTokens.value.totalPages != 0){
        page = paginationTokens.value.totalPages
      }
      loadingTokens.value = true;
      try {
          const response = await api.get('/api/Account/tokens', {
              params: {
                  status: filtersTokens.value.status,
                  searchTerm: filtersTokens.value.searchTerm,
                  page: page
              }
          });

          // Actualizamos los datos
          refreshTokens.value = response.data.items;
          paginationTokens.value = {
              pageNumber: response.data.pageNumber,
              totalPages: response.data.totalPages,
              totalCount: response.data.totalCount,
              pageSize: response.data.pageSize,
          };

      } catch (error) {
          console.error("Error al obtener los refresh tokens:", error);
          // Podrías agregar una notificación de error aquí
      } finally {
          loadingTokens.value = false;
      }
    };

    // Observador (watcher) para que los filtros se apliquen automáticamente
    watch(filtersTokens, () => {
        // Debouncing para el buscador, para no llamar a la API en cada tecla
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            fetchRefreshTokens(1); // Al cambiar un filtro, volvemos a la página 1
        }, 300); // Espera 300ms después de que el usuario deja de escribir
    }, { deep: true });


    // Funciones auxiliares para la vista
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(new Date(dateString).setHours(new Date(dateString).getHours() - 3)).toLocaleString('es-AR', {
            hour12: false,
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getTokenStatus = (token) => {
        if (token.revoked && !token.replacedByToken) {
          return { text: 'revocado', class: 'badge-revocado' };
        }
        if (token.revoked && token.replacedByToken) {
          return { text: 'antiguo', class: 'badge-revocado' };
        } 

        // 1. Asegúrate de que la cadena tenga el formato correcto para ser GMT 0
        const fechaExpiracionString = token.expires.includes('Z') 
            ? token.expires 
            : `${token.expires}Z`; // Añadimos la 'Z' si no está presente

        // La fecha de expiración ahora se interpretará como UTC:
        const fechaExpiracion = new Date(fechaExpiracionString);

        // La fecha actual (new Date()) internamente es UTC, y su comparación también lo será.
        const ahora = new Date();

        // 3. Realiza la comparación con el método más seguro (Milisegundos)
        if (fechaExpiracion.getTime() < ahora.getTime()) {
        // ^^^ Esta comparación usa el valor absoluto (milisegundos) y es siempre correcta.
            return { text: 'expirado', class: 'badge-expirado' };
        }
        return { text: 'activo', class: 'badge-activo' };
    };

    // Función para cambiar el estado del filtro al hacer clic en una tarjeta
    const setTokenStatusFilter = (status) => {
      //Si es distinto, guardar el nuevo status, sino vaciarlo
      if(filtersTokens.value.status != status){
        filtersTokens.value.status = status;
      } else {
        filtersTokens.value.status = ''
      }
    };

    const revokingTokenId = ref(null); // Para mostrar un spinner en el botón específico

    const revokeToken = async (token) => {
      // Pedimos confirmación al usuario
      if (!confirm(t('confirmarRevocarToken'))) {
        return;
      }

      revokingTokenId.value = token.id; // Activamos el estado de carga para este token
      
      try {
        await api.post('/api/Account/revoke', {
          RefreshToken: token.token // El cuerpo de la petición
        });

        // Opcional: Mostrar una notificación de éxito
        //alert(t('tokenRevocadoExito'));

        // Recargamos la lista de tokens para que se actualice la vista
        fetchRefreshTokens(paginationTokens.value.pageNumber);

      } catch (error) {
        console.error("Error al revocar el token:", error);
        // Opcional: Mostrar una notificación de error
        alert(t('errorRevocarToken'));
      } finally {
        revokingTokenId.value = null; // Desactivamos el estado de carga
      }
    };
    
    const linkLogs = computed(() => {
      return `${API_BASE_URL}seq/`;
    });

    onBeforeUnmount(() => {
      // Limpia el intervalo al desmontar el componente
      clearInterval(interval);
    });
    
    onMounted(async () => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)
      
      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      if (isTokenValid()) {
        console.log('El token es válido.');
      }
      
      await checkAuth();
      fetchUsers();
      fetchDriveStorage();
      fetchRefreshTokens();
    })
    
    return {
      message,
      imageUrl,
      t,
      user,
      loadingUsers,
      usersConectados,
      fetchUsers,
      handleClick,
      isSpinning,
      handleClickToken,
      isSpinningToken,
      refreshTokens,
      loadingTokens,
      paginationTokens,
      filtersTokens,
      fetchRefreshTokens,
      formatDate,
      getTokenStatus,
      setTokenStatusFilter,
      revokeToken,
      revokingTokenId,
      linkLogs,
      driveStorage,
      loadingDrive,
      isCleaningDrive,
      ejecutarLimpiezaDrive
    }
  }
}
</script>
<style scoped>
.item-docentes{
  width: 80vw;
  max-width: 500px;
}
.item-home{
  width: 400px;
  max-width: 80vw;
}

@media (min-width: 992px) {
  .item-home {
    width: 30vw;
    max-width: 400px;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}

/* Aplica la animación cuando la clase 'spinning' está presente */
.spinning {
  animation: spin 0.2s linear forwards; /* 1s de duración, lineal, se mantiene al final */
}
</style>